import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["toggle"]
  static targets = ["togglable"]
  static values = { toggled: Boolean, default: false }

  toggledValueChanged(value) {
    if (value) {
      this.toggle()
    }
  }

  toggle() {
    for (const target of this.togglableTargets) {
      this._toggleTargetClasses(target)
    }
    this.dispatch("toggle")
  }

  _toggleTargetClasses(target) {
    for (const toggleClass of this.toggleClasses) {
      target.classList.toggle(toggleClass)
    }
  }
}
